import { FC } from "react";
import { Select, Space } from "antd";
import { clsx } from "clsx";
import { NegotiationStatus } from "../../../../types/NegotiationTypes";
import { negotiationStatusToString } from "../../../negotiations/NegotiationStatusTag";
import { GenericSelect } from "../../../../common/GenericSelect";
import classes from "./ToolBox.module.less";

export interface ToolboxProps {
    status?: NegotiationStatus;
    onStatusChange?: (status: NegotiationStatus) => void;
    className?: string;
}

export const Toolbox: FC<ToolboxProps> = ({ status, onStatusChange, className }) => {
    return (
        <Space size={10} className={clsx(classes.container, className)}>
            <GenericSelect value={status} onSelect={onStatusChange} className={classes.status}>
                {Object.values(NegotiationStatus).map((status) => {
                    return (
                        <Select.Option value={status}>
                            {negotiationStatusToString(status)}
                        </Select.Option>
                    );
                })}
            </GenericSelect>
        </Space>
    );
};
